import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  lang: string = "en";

  constructor(private translate: TranslateService, private route: ActivatedRoute, private titleService: Title) {
    translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');
    this.setDefaultTranslation(); 
       
    /*
    //Langue définie par le paramètre ?lang=XX
    route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang !== undefined) {
        console.log("EN");
        translate.use(this.lang);
      } else {
        t
      }
    });
    */
  }

  private setDefaultTranslation(): void {
    // if (['fr', 'en'].indexOf(this.translate.getBrowserLang()) > -1) {
    //   this.translate.use(this.translate.getBrowserLang());
    // } else {
    //   this.translate.use('en'); 
    // }

    this.translate.use('en');
  }

  ngOnInit() {
   
  }


  
}
